import { getApiBaseUrl } from '../utilities/env-utilities';

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // Health Dashboard
  DASHBOARD: '/api/health/dashboard',
  TRIGGER_DASHBOARD: '/api/health/dashboard/trigger',
  
  // Users
  USERS: '/api/users',
  CURRENT_USER: '/api/users/me',
  USER_BY_ID: (id: string) => `/api/users/${id}`,
  
  // Roles
  ROLES: '/api/roles',
  ROLE_BY_ID: (id: string) => `/api/roles/${id}`,
  PERMISSIONS: '/api/permissions',
  
  // Audit
  AUDIT: '/api/audit',

  // Log Oracle
  TRANSACTION_BY_ID: (transactionId: string) =>
    `/api/log-oracle/transactions/${transactionId}`,
  LIST_JOBS: '/api/log-oracle/jobs/list',
  JOB_DETAILS: (params: { region: string; transactionId: string }) =>
    `/api/log-oracle/jobs?region=${encodeURIComponent(params.region)}&transactionId=${encodeURIComponent(params.transactionId)}`,

  // AI Knowledge Base
  KB_ARTICLES: '/api/log-oracle/kb/articles',
  KB_ARTICLE_BY_ID: (articleId: string) => `/api/log-oracle/kb/articles/${articleId}`,
  KB_ARTICLE_VERSIONS: (articleId: string) => `/api/log-oracle/kb/articles/${articleId}/versions`,
  KB_ARTICLE_VERSION: (articleId: string, versionId: string) =>
    `/api/log-oracle/kb/articles/${articleId}/versions/${encodeURIComponent(versionId)}`,
  KB_TAGS: '/api/log-oracle/kb/tags',
  KB_TAG_BY_ID: (tagId: string) => `/api/log-oracle/kb/tags/${tagId}`,

  // S3
  S3_DIRECTORY: '/api/s3/directory',
  S3_READ: '/api/s3/read',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const DEFAULT_HEADERS: Record<string, string> = {
  'Content-Type': 'application/json',
};

